import React from 'react'
import { Grid, Card, CardContent, Skeleton, Box, Typography } from '@mui/material'

const SkeletonGrid = () => {
  const titles = [
    'Requests',  
    'Box Details',
    'Exceptions',
    'Transmittal Sheet Exceptions',  
    // 'Image Exception' 
  ]

  return (
    <Box sx={{ padding: 3 }}>
      <Grid container spacing={2}>
        {[1, 2, 3, 4].map((_, index) => ( 
          <Grid item xs={12} sm={3} key={index}>
            <Card sx={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%', boxShadow: 3 }}>
              <CardContent sx={{ flexGrow: 1 }}>
                {/* Title for each card */}
                <Typography variant="h6" gutterBottom sx={{ color: '#D3D3D3', fontSize: '1.1rem', marginLeft: '-10px', marginRight: '-10px' }}>
                  {titles[index]} {/* Display title based on card index */}
                </Typography>

                <Grid container spacing={2}>
                  {/* First row with 2 items */}
                  <Grid item xs={12} sm={6}>
                    <Skeleton variant="rectangular" width={70} height={25} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Skeleton variant="rectangular" width={70} height={25} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Skeleton variant="rectangular" width={70} height={25} />
                  </Grid>
                  {index === 1 && (  
                    <>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid> */}
                      {/* <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid> */}
                      {/* <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid> */}
                    </>
                  )}

                  {/* Third row with 1 item */}
                  {index === 2 && (  
                    <>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Skeleton variant="rectangular" width={70} height={25} />
                      </Grid> */}
                    </>
                  )}

                  {/* Fourth row with 1 item */}
                  <Grid item xs={12} sm={6}>
                    <Skeleton variant="rectangular" width={70} height={25} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Skeleton variant="rectangular" width={70} height={25} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Skeleton variant="rectangular" width={70} height={25} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default SkeletonGrid